import { SummaryFooter } from "./summary-footer";

export class PageableResult {
  private start: number;
  private end: number;
  private totalItems: number;
  private items: Array<object>;
  private summaryFooter: SummaryFooter;

  constructor() {
    this.items = [];
  }

  getItems(): Array<object> {
    return this.items;
  }

  setItems(items: Array<object>): void {
    this.items = items;
  }

  setEnd(end: number): void {
    this.end = end + this.start - 1;
  }

  addItems(items: Array<object>): void {
    this.items = this.items.concat(items);
  }

  setStart(start: number): void {
    this.start = start;
  }

  setTotalItems(totalItems: number): void {
    this.totalItems = totalItems;
  }

  setSummaryFooter(summaryFooter: SummaryFooter): void {
    this.summaryFooter = summaryFooter;
  }

  filterByPageNumber(pageNumber: number) {
    const itemsPerPage = this.end - this.start + 1;
    this.start = pageNumber * itemsPerPage - (itemsPerPage - 1);
    this.end = this.start + itemsPerPage - 1;
    this.items = this.items.slice(this.start - 1, this.end);
  }

  filterByItemsPerPage(itemsPerPage: number) {
    this.start = 1;
    this.end = itemsPerPage;
    this.items = this.items.slice(0, itemsPerPage);
  }

  getItemsPerPage(): number {
    return this.end - this.start + 1;
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / (this.end + 1 - this.start));
  }

  getPageNumbers(): Array<number> {
    const pageNumbers = new Array<number>();
    for (let i = 0; i < this.getTotalPages(); i++) {
      pageNumbers.push(i + 1);
    }
    return pageNumbers;
  }

  getTotalItems(): number {
    return this.totalItems;
  }

  getStart(): number {
    return this.start;
  }

  getEnd(): number {
    return this.end;
  }

  getSummaryFooter(): SummaryFooter {
    return this.summaryFooter;
  }
}
